import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const FEATURES = [
  { icon: 'ti-calendar-event',  text: 'Gestión de turnos y agenda' },
  { icon: 'ti-report-medical',  text: 'Historia clínica completa' },
  { icon: 'ti-microscope',      text: 'Laboratorio y resultados' },
  { icon: 'ti-receipt',         text: 'Facturación integrada' },
  { icon: 'ti-brand-whatsapp',  text: 'Chatbot de citas por WhatsApp' },
  { icon: 'ti-sparkles',        text: 'Asistente clínico con IA' },
];

export default function Login() {
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ usuario: '', password: '' });
  const [clock, setClock] = useState('');
  const [fecha, setFecha] = useState('');

  useEffect(() => {
    const tick = () => {
      setClock(new Date().toLocaleTimeString('es-EC'));
      setFecha(new Date().toLocaleDateString('es-EC', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const ok = await login(form.usuario, form.password);
    if (ok) navigate('/');
  };

  return (
    <div className="login-page">

      {/* ── Panel izquierdo ── */}
      <div className="login-left" style={{
        background: 'linear-gradient(145deg, #0d1f3c 0%, #1a3a5c 60%, #0d2d4a 100%)',
        position: 'relative', overflow: 'hidden'
      }}>

        {/* Círculos decorativos de fondo */}
        <div style={{ position:'absolute', top:-80, right:-80, width:300, height:300, borderRadius:'50%', background:'rgba(33,150,243,0.06)', pointerEvents:'none' }}/>
        <div style={{ position:'absolute', bottom:-60, left:-60, width:240, height:240, borderRadius:'50%', background:'rgba(33,150,243,0.05)', pointerEvents:'none' }}/>

        {/* Ilustración vectorial médica de fondo */}
        <svg style={{ position:'absolute', right:0, top:'50%', transform:'translateY(-50%)', opacity:0.08, pointerEvents:'none' }}
          width="340" height="340" viewBox="0 0 320 320">
          <circle cx="160" cy="160" r="140" fill="none" stroke="white" strokeWidth="1"/>
          <circle cx="160" cy="160" r="100" fill="none" stroke="white" strokeWidth="0.5"/>
          <circle cx="160" cy="160" r="60" fill="none" stroke="white" strokeWidth="0.5"/>
          <rect x="140" y="80" width="40" height="160" rx="8" fill="white"/>
          <rect x="80" y="140" width="160" height="40" rx="8" fill="white"/>
          <circle cx="60" cy="60" r="6" fill="white"/>
          <circle cx="260" cy="60" r="6" fill="white"/>
          <circle cx="60" cy="260" r="6" fill="white"/>
          <circle cx="260" cy="260" r="6" fill="white"/>
        </svg>

        {/* Ilustración central — estetoscopio + EKG */}
        <svg style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', pointerEvents:'none' }}
          width="220" height="220" viewBox="0 0 200 200">
          <circle cx="100" cy="78" r="34" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="11"/>
          <line x1="100" y1="112" x2="100" y2="148" stroke="rgba(255,255,255,0.12)" strokeWidth="8" strokeLinecap="round"/>
          <circle cx="100" cy="156" r="11" fill="rgba(33,150,243,0.35)" stroke="rgba(255,255,255,0.25)" strokeWidth="3"/>
          <polyline points="10,100 35,100 47,72 58,128 68,82 78,100 122,100 134,68 146,132 156,100 190,100"
            fill="none" stroke="rgba(33,150,243,0.55)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

        <div className="login-brand" style={{ zIndex:1, position:'relative' }}>

          {/* Logo */}
          <div style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:12, marginBottom:8 }}>
            <svg width="48" height="48" viewBox="0 0 48 48">
              <ellipse cx="24" cy="22" rx="15" ry="11" fill="white"/>
              <ellipse cx="13" cy="26" rx="10" ry="8" fill="white"/>
              <ellipse cx="35" cy="27" rx="9" ry="7" fill="white"/>
              <rect x="7" y="22" width="30" height="9" fill="white"/>
              <rect x="19" y="12" width="9" height="20" rx="3" fill="#2196F3"/>
              <rect x="14" y="17" width="19" height="9" rx="3" fill="#2196F3"/>
            </svg>
            <div style={{ textAlign:'left' }}>
              <div style={{ fontSize:26, fontWeight:700, color:'white', lineHeight:1, letterSpacing:-0.5 }}>
                Medi<span style={{ fontWeight:300, color:'#64B5F6' }}>Cloud</span>
              </div>
              <div style={{ fontSize:10, color:'#7eb8e8', letterSpacing:3, marginTop:2 }}>SISTEMA CLÍNICO</div>
            </div>
          </div>

          {/* Reloj */}
          <div style={{ fontSize:38, fontWeight:200, color:'#fff', fontVariantNumeric:'tabular-nums', letterSpacing:2, marginTop:32 }}>
            {clock}
          </div>
          <div style={{ marginTop:4, fontSize:12, color:'#7eb8e8', textTransform:'capitalize' }}>
            {fecha}
          </div>

          {/* Divisor */}
          <div style={{ width:40, height:2, background:'linear-gradient(90deg,#2196F3,transparent)', margin:'24px auto' }}/>

          {/* Features */}
          <div style={{ display:'flex', flexDirection:'column', gap:10, maxWidth:260, margin:'0 auto', textAlign:'left' }}>
            {FEATURES.map(f => (
              <div key={f.text} style={{ display:'flex', alignItems:'center', gap:10, fontSize:12, color:'#a8cce8' }}>
                <div style={{ width:28, height:28, borderRadius:7, background:'rgba(33,150,243,0.15)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <i className={`ti ${f.icon}`} style={{ fontSize:14, color:'#4da8e8' }} aria-hidden="true"/>
                </div>
                {f.text}
              </div>
            ))}
          </div>

          <div style={{ marginTop:28, fontSize:10, color:'#3d6a8a', letterSpacing:1 }}>
            © {new Date().getFullYear()} MediCloud · Ecuador
          </div>
        </div>
      </div>

      {/* ── Panel derecho ── */}
      <div className="login-right" style={{ position:'relative' }}>
        <div className="login-form">

          <div style={{ marginBottom:28 }}>
            <div style={{ fontSize:22, fontWeight:700, color:'var(--text)', letterSpacing:-0.5 }}>
              Bienvenido a <span style={{ color:'#2196F3' }}>Medi</span><span style={{ color:'var(--text2)', fontWeight:300 }}>Cloud</span>
            </div>
            <div className="login-sub">Ingresa tus credenciales para continuar</div>
          </div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">
                <i className="ti ti-user" style={{ marginRight:5, fontSize:12 }} aria-hidden="true"/>
                Usuario
              </label>
              <input className="form-control" placeholder="Ej: AALVAREZ"
                value={form.usuario}
                onChange={e => setForm(f => ({ ...f, usuario: e.target.value }))}
                autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">
                <i className="ti ti-lock" style={{ marginRight:5, fontSize:12 }} aria-hidden="true"/>
                Contraseña
              </label>
              <input type="password" className="form-control" placeholder="••••••••"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            </div>
            <button type="submit" className="btn btn-primary"
              style={{ width:'100%', justifyContent:'center', padding:'11px', marginTop:12, fontSize:13, borderRadius:8, display:'flex', alignItems:'center', gap:8 }}
              disabled={loading}>
              {loading
                ? <><i className="ti ti-loader-2" style={{ fontSize:15 }} aria-hidden="true"/> Ingresando...</>
                : <><i className="ti ti-login" style={{ fontSize:15 }} aria-hidden="true"/> Ingresar al sistema</>
              }
            </button>
          </form>

          <div style={{ marginTop:20, background:'var(--bg)', borderRadius:8, padding:'12px 14px', border:'1px solid var(--border)' }}>
            <div style={{ fontSize:11, color:'var(--text3)', lineHeight:1.7 }}>
              <i className="ti ti-info-circle" style={{ fontSize:12, marginRight:5, verticalAlign:-1 }} aria-hidden="true"/>
              Usa las mismas credenciales de tu sistema anterior.
            </div>
          </div>
        </div>

        {/* Badge flotante de contacto */}
        <div style={{
          position:'absolute', bottom:24, right:24,
          background:'#1a3a5c', borderRadius:10,
          padding:'10px 14px', maxWidth:210,
          boxShadow:'0 4px 20px rgba(0,0,0,0.25)'
        }}>
          <div style={{ fontSize:9, color:'#64B5F6', letterSpacing:1.5, marginBottom:7, fontWeight:500 }}>
            ¿NECESITAS AYUDA?
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:7, marginBottom:5 }}>
            <i className="ti ti-phone" style={{ fontSize:13, color:'#4da8e8' }} aria-hidden="true"/>
            <span style={{ fontSize:12, color:'white', fontWeight:500 }}>+593 0987540707</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:7 }}>
            <i className="ti ti-mail" style={{ fontSize:13, color:'#4da8e8' }} aria-hidden="true"/>
            <span style={{ fontSize:11, color:'#90CAF9' }}>jcaicedofix@gmail.com</span>
          </div>
        </div>

      </div>
    </div>
  );
}
